module.exports = __webpack_public_path__ + "img/656.3c163db7.jpg";